import { Box, Button, Grid, Stack, TextField } from '@mui/material';
import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toastr from "toastr";
import { toastrCustomOptions, toastrCustomOptionsLonger } from '../../constants/toastrOptions';
import { getOrganisationData, resetResponseState, unsetLoading } from '../../store/appAction';
import CancelModal from '../Modal/CancelModal';
import { EDIT } from '../../constants/modes';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


const OfficeForm = props => {
    const {
        values: {
            id,
            name,
            organisationId,
            file
        },
        errors,
        touched,
        handleSubmit,
        handleChange,
        handleReset,
        resetForm,
        mode,
        role,
        setFieldValue
    } = props;
    toastr.options = toastrCustomOptions;
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const { successMsg, errorMsg } = useSelector(state => state.common);
    const [modalOpen, setModalOpen] = useState(false);
    const [preview, setPreview] = useState(false);
    const fileInput = useRef(null);

    useEffect(() => {
        dispatch(getOrganisationData());
        return () => {
            resetForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (successMsg || errorMsg) {
            dispatch(unsetLoading());
            if (successMsg) {
                (mode !== EDIT) && resetForm();
                toastr.success(successMsg);
            }
            errorMsg && toastr.error(errorMsg, undefined, toastrCustomOptionsLonger);
            dispatch(resetResponseState());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successMsg, errorMsg]);

    useEffect(() => {
        if(file){
            if(file instanceof Blob){
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () =>{ setPreview(reader?.result)}
            }else{
                setPreview(file)
            }
        }else{
            setPreview(null)
        }
    }, [file]);

    const handleCancelModalResponse = (positiveResponse) => {
        setModalOpen(false);
        if (positiveResponse) {
           window.scrollY = 0;
            handleReset();
        }
    }

    const handleBackResponse = () => {
        navigate('/admin/organisations/list');
    }

    const handleImageUploadButtonClick = (event) => {
        fileInput.current.click();
    };

    const handleRemoveImage = (event) => {
        setPreview(null);
        setFieldValue('file', file);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                const img = new Image();
                img.onload = () => {
                    if (img.width > 200 || img.height > 200) {
                        toastr.error("Image upload error: The selected image is problematic. Please ensure it is smaller than 200 x 200 pixels and in either JPG or PNG format. Kindly select a different image.", undefined, toastrCustomOptionsLonger);
                    } else {
                        setFieldValue('file', file);
                    }
                };
                img.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
        }
    }
    

    return (
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3, p: 1, ml: 20, pr: 30 }}>
                <Grid
                    spacing={1}
                    container
                    direction="column"
                    justifyContent="space-evenly"
                    alignItems="stretch"
                >
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            id="name"
                            name="name"
                            autoComplete="name"
                            label="Office Name"
                            helperText={touched.name ? errors.name : ""}
                            error={Boolean(errors.name)}
                            value={name}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button variant="outlined" sx={{ left: 'auto', textTransform: 'none' }}
                            onClick={handleImageUploadButtonClick}>
                            Choose logo
                        </Button>

                        <div>
                            <input
                                type='file'
                                name='file'
                                accept='image/*'
                                ref={fileInput}
                                style={{ display: "none" }}
                                onChange={(e) => { handleImageChange(e) }}
                            />
                        </div>
                    </Grid>
   
                    <Grid item xs={12} sm={6}>
                        {(preview) &&
                            <div style={{  position:'relative', display:'inline-block' }}>
                                <IconButton style={{ position:'absolute', top:'5px', left:'5px' }} onClick={ handleRemoveImage }>
                                    <CloseIcon style={{ background: '#f9cdcd', borderRadius:'10px' , padding:'3px'}}/>
                                </IconButton>
                                 <img src={ preview } style={{ width:'300px', display:'block', maxWidth:'100%', height:'auto' }}/>
                            </div>
                        }
                    </Grid>
                    <Stack spacing={2} sx={{ marginLeft: 'auto', marginTop: 3 }} direction="row" >
                        <Button variant="outlined" sx={{ left: 'auto', textTransform: 'none' }}
                            onClick={handleBackResponse}>
                            Back
                        </Button>
                        <Button variant="outlined" sx={{ textTransform: 'none' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setModalOpen(true);
                            }}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" sx={{ textTransform: 'none' }}>
                            Save
                        </Button>
                    </Stack>
                </Grid>
                <CancelModal isOpen={modalOpen} handleResponse={handleCancelModalResponse} />
            </Box>
    )
}

export default OfficeForm